import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "i18n/locales/en.json";

const resources = {
  en: {
    translation: en,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  //default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
